import React from 'react';

/**
 * Property Input Component - Generic input wrapper
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PropertyInput = _ref => {
  let {
    label,
    children,
    className = "property-group"
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: className,
    children: [label && /*#__PURE__*/_jsx("label", {
      children: label
    }), children]
  });
};

/**
 * Text Input Property
 */
export const TextProperty = _ref2 => {
  let {
    label,
    value,
    onChange,
    placeholder,
    className = "property-input"
  } = _ref2;
  return /*#__PURE__*/_jsx(PropertyInput, {
    label: label,
    children: /*#__PURE__*/_jsx("input", {
      type: "text",
      value: value || '',
      onChange: e => onChange(e.target.value),
      className: className,
      placeholder: placeholder
    })
  });
};

/**
 * Textarea Property
 */
export const TextareaProperty = _ref3 => {
  let {
    label,
    value,
    onChange,
    placeholder,
    rows = 2,
    className = "property-input"
  } = _ref3;
  return /*#__PURE__*/_jsx(PropertyInput, {
    label: label,
    children: /*#__PURE__*/_jsx("textarea", {
      value: value || '',
      onChange: e => onChange(e.target.value),
      className: className,
      placeholder: placeholder,
      rows: rows
    })
  });
};

/**
 * Select Property
 */
export const SelectProperty = _ref4 => {
  let {
    label,
    value,
    onChange,
    options,
    className = "property-input"
  } = _ref4;
  return /*#__PURE__*/_jsx(PropertyInput, {
    label: label,
    children: /*#__PURE__*/_jsx("select", {
      value: value || '',
      onChange: e => onChange(e.target.value),
      className: className,
      children: options.map((option, index) => /*#__PURE__*/_jsx("option", {
        value: option.value,
        children: option.label
      }, index))
    })
  });
};

/**
 * Checkbox Property
 */
export const CheckboxProperty = _ref5 => {
  let {
    label,
    checked,
    onChange,
    className = "checkbox-label"
  } = _ref5;
  return /*#__PURE__*/_jsx(PropertyInput, {
    children: /*#__PURE__*/_jsxs("label", {
      className: className,
      children: [/*#__PURE__*/_jsx("input", {
        type: "checkbox",
        checked: checked || false,
        onChange: e => onChange(e.target.checked)
      }), label]
    })
  });
};

/**
 * Number Input Property
 */
export const NumberProperty = _ref6 => {
  let {
    label,
    value,
    onChange,
    placeholder,
    className = "property-input"
  } = _ref6;
  return /*#__PURE__*/_jsx(PropertyInput, {
    label: label,
    children: /*#__PURE__*/_jsx("input", {
      type: "number",
      value: value || '',
      onChange: e => onChange(e.target.value ? Number(e.target.value) : ''),
      className: className,
      placeholder: placeholder
    })
  });
};

/**
 * Default Value Input - Handles different input types based on field type
 */
export const DefaultValueInput = _ref7 => {
  let {
    field,
    value,
    onChange
  } = _ref7;
  const fieldType = field?.type || field;
  if (fieldType === 'textarea') {
    return /*#__PURE__*/_jsx("textarea", {
      value: value || '',
      onChange: e => onChange(e.target.value),
      className: "property-input",
      placeholder: "Enter default value",
      rows: 4
    });
  }
  const inputType = fieldType === 'number' || fieldType === 'range' ? 'number' : ['date', 'time', 'datetime-local', 'month', 'week'].includes(fieldType) ? fieldType : 'text';
  return /*#__PURE__*/_jsx("input", {
    type: inputType,
    value: value || '',
    onChange: e => onChange(e.target.value),
    className: "property-input",
    placeholder: "Enter default value"
  });
};

/**
 * Default Selection Input - For select, radio, checkbox fields
 */
export const DefaultSelectionInput = _ref8 => {
  let {
    field,
    options,
    value,
    onChange
  } = _ref8;
  const fieldOptions = options || field?.options;
  return /*#__PURE__*/_jsxs("select", {
    value: value || '',
    onChange: e => onChange(e.target.value),
    className: "property-input",
    children: [/*#__PURE__*/_jsx("option", {
      value: "",
      children: "None"
    }), fieldOptions && fieldOptions.map((option, index) => /*#__PURE__*/_jsx("option", {
      value: option.value,
      children: option.label
    }, index))]
  });
};

/**
 * Column Width Select
 */
export const ColumnWidthSelect = _ref9 => {
  let {
    value,
    onChange
  } = _ref9;
  return /*#__PURE__*/_jsx(PropertyInput, {
    label: null,
    children: /*#__PURE__*/_jsxs("select", {
      value: value || '1',
      onChange: e => onChange(e.target.value),
      className: "property-input",
      children: [/*#__PURE__*/_jsx("option", {
        value: "1",
        children: "Full Width (1)"
      }), /*#__PURE__*/_jsx("option", {
        value: "1/2",
        children: "Half Width (1/2)"
      }), /*#__PURE__*/_jsx("option", {
        value: "1/3",
        children: "Third Width (1/3)"
      }), /*#__PURE__*/_jsx("option", {
        value: "1/4",
        children: "Quarter Width (1/4)"
      })]
    })
  });
};